enum TipoReservaSalaEnum {
  Cirurgia = 'Cirurgia',
  PreAgendamento = 'PreAgendamento',
  PreparoDeSala = 'PreparoDeSala',
  AgendamentoApenasNoHis = 'AgendamentoApenasNoHis',
  DataVirtual = 'DataVirtual',
  CirurgiaNaoAutorizada = 'CirurgiaNaoAutorizada',
  ReservaPreferencial = 'ReservaPreferencial',
  ReservaDeBloqueio = 'ReservaDeBloqueio',
}

export default TipoReservaSalaEnum
